import { Car, Locale, Timestamp, InputType } from 'src/types'

import { FuelType } from 'src/pages/FuelTracking/enums'

export const getSimpleFields = (
  locale: Locale['trackFuel'],
  isTotalCostReadOnly?: boolean,
  isElectricCar: boolean = false,
  isElectricType: boolean = false,
) => {
  const { addInfoFuel: fieldsLocale } = locale

  return [
    {
      title: fieldsLocale.address,
      placeHolder: fieldsLocale.addressPlaceholder,
      inputType: InputType.TEXT,
      name: 'address',
      isReadOnly: false,
    },
    {
      title: fieldsLocale.odometer,
      placeHolder: fieldsLocale.odometerPlaceholder,
      inputType: InputType.NUMBER,
      name: 'odometer',
      isReadOnly: false,
    },
    {
      title: fieldsLocale.fuelType,
      placeHolder: fieldsLocale.fuelTypePlaceholder,
      inputType: InputType.SELECT,
      name: 'fuelType',
      isReadOnly: isElectricCar,
    },
    {
      title: isElectricType
        ? fieldsLocale.fuelQuantityElectricity
        : fieldsLocale.fuelQuantity,
      placeHolder: fieldsLocale.fuelQuantityPlaceholder,
      inputType: InputType.NUMBER,
      name: 'fuelQuantity',
      isReadOnly: false,
    },
    {
      title: isElectricType
        ? fieldsLocale.pricePerKwh
        : fieldsLocale.pricePerLiter,
      placeHolder: fieldsLocale.pricePerLiterPlaceHolder,
      inputType: InputType.NUMBER,
      name: 'pricePerLiter',
      isReadOnly: false,
    },
    {
      title: fieldsLocale.totalCost,
      placeHolder: fieldsLocale.totalCostPlaceholder,
      inputType: InputType.NUMBER,
      name: 'totalCost',
      isReadOnly: !!isTotalCostReadOnly,
    },
  ] as const
}

export const getFuelTypeOptions = (locale: Locale['trackFuel']) => {
  const { addInfoFuel: fieldsLocale } = locale

  return [
    {
      value: FuelType.DIESEL,
      label: fieldsLocale.diesel,
    },
    {
      value: FuelType.GAS,
      label: fieldsLocale.gas,
    },
    {
      value: FuelType.Electricity,
      label: fieldsLocale.electric,
    },
    {
      value: FuelType.PETROL92,
      label: fieldsLocale.petrol92,
    },
    {
      value: FuelType.PETROL95,
      label: fieldsLocale.petrol95,
    },
    {
      value: FuelType.PETROL98,
      label: fieldsLocale.petrol98,
    },
    {
      value: FuelType.PETROL100,
      label: fieldsLocale.petrol100,
    },
  ] as const
}

export const getTotalCost = (
  pricePerLiter: string,
  fuelQuantity: string,
): number => {
  const pricePerLiterNum = Number(pricePerLiter)
  const fuelQuantityNum = Number(fuelQuantity)

  if (pricePerLiterNum && fuelQuantityNum) {
    return fuelQuantityNum * pricePerLiterNum
  }

  return 0
}

export function getActiveCar(
  cars?: Car<Timestamp>[],
): Car<Timestamp> | undefined {
  if (!cars) return

  return cars.find(car => car.isActive)
}
